import axios from 'axios';
import * as Routes from '@/modules/routes';
import { debounce } from '@/modules/TCIUtils';

type IFetchSlideShowTotalScore = {
  slideShowId: number;
  setSlideShowTotalScore: (totalScore: number) => void;
};

// Debounced function to prevent duplicate requests across all component instances
const debouncedFetch = debounce((slideShowId: number, setSlideShowTotalScore: (totalScore: number) => void) => {
  axios.get(Routes.plato_api_slide_show_path(slideShowId, { only: ['slide_show_total_score'] }))
    .then((res) => {
      const totalScore = res.data.slideShowTotalScore;
      setSlideShowTotalScore(totalScore);
    });
}, 100);

const fetchSlideShowTotalScore = ({ slideShowId, setSlideShowTotalScore }: IFetchSlideShowTotalScore) => (
  debouncedFetch(slideShowId, setSlideShowTotalScore)
);

export default fetchSlideShowTotalScore;
